export const SeoMeta = {
  wishlist: {
    title: "위시리스트",
    description:
      "칼렛스토어 위시리스트에서 관심있는 상품을 한눈에 확인하고 관리하세요. 가격, 재고 확인 및 장바구니 담기까지 손쉽게 이용 가능합니다.",
    keywords:
      "칼렛스토어, 위시리스트, 관심상품, 찜한상품, 상품목록, 장바구니, 쇼핑몰, 온라인쇼핑",
  },
  customer: {
    title: "고객센터",
    description:
      "고객센터 페이지입니다. 자주 묻는 질문, 1:1 문의, 교환 및 환불 안내를 확인하실 수 있습니다.",
    keywords:
      "고객센터, 칼렛스토어, 고객문의, FAQ, 자주묻는질문, 1:1문의, 주문문의, 배송문의, 교환반품, 환불절차, 이용안내, 고객지원, 문의하기",
  },
  checkout: {
    title: "결제하기",
    description:
      "칼렛스토어 결제 페이지입니다. 다양한 결제 방법으로 친환경 포장재를 안전하고 편리하게 구매하세요. 배송 정보와 할인 쿠폰도 확인 가능합니다.",
    keywords:
      "결제하기, 칼렛스토어, 주문결제, 안전결제, 온라인결제, 카드결제, 친환경포장구매, 결제페이지, 주문완료",
  },
  checkoutComplete: {
    title: "결제완료",
    description:
      "칼렛스토어 결제완료 페이지입니다. 주문하신 친환경 포장재의 결제가 성공적으로 완료되었습니다. 주문 내역과 배송 정보를 확인하세요.",
    keywords:
      "결제완료, 칼렛스토어, 주문확인, 결제성공, 주문내역, 배송정보, 주문완료, 영수증, 주문번호",
  },
  signUp: {
    title: "회원가입",
    description:
      "칼렛스토어 회원가입 페이지입니다. 가입 즉시 사용 가능한 5만원 쿠폰팩을 받고 친환경 포장재와 패키징 솔루션을 합리적인 가격에 만나보세요.",
    keywords:
      "칼렛스토어, 회원가입, 신규회원, 쿠폰팩, 가입혜택, 회원특전, 친환경포장재, 무료쿠폰, 회원등록",
  },
  login: {
    title: "로그인",
    description:
      "칼렛스토어 로그인 페이지입니다. 회원 계정으로 접속하여 친환경 포장재 쇼핑과 주문 내역 확인, 맞춤 서비스를 이용하세요.",
    keywords:
      "칼렛스토어, 로그인, 회원접속, 계정로그인, 회원인증, 로그인페이지, 회원서비스, 계정접속",
  },
  findId: {
    title: "아이디 찾기",
    description:
      "칼렛스토어 아이디 찾기 페이지입니다. 회원가입 시 등록한 정보로 잊어버린 아이디를 쉽게 찾을 수 있습니다.",
    keywords:
      "칼렛스토어, 아이디찾기, 계정찾기, 회원정보확인, 로그인정보, 아이디확인, 계정확인, 회원아이디",
  },
  findPw: {
    title: "비밀번호 찾기",
    description:
      "칼렛스토어 비밀번호 찾기 페이지입니다. 가입 정보를 통해 간편하게 비밀번호를 재설정하고 계정에 다시 접속하세요.",
    keywords:
      "칼렛스토어, 비밀번호찾기, 비밀번호재설정, 계정복구, 로그인도움, 비밀번호분실, 계정접속, 비밀번호초기화",
  },
  memberWithdrawal: {
    title: "회원탈퇴",
    description:
      "칼렛스토어 회원탈퇴 페이지입니다. 회원 정보 삭제 및 계정 해지에 관한 절차와 유의사항을 확인하실 수 있습니다.",
    keywords:
      "칼렛스토어, 회원탈퇴, 계정삭제, 회원정보삭제, 계정해지, 마이페이지, 개인정보삭제, 회원해지",
  },
  orderInquiry: {
    title: "주문 조회",
    description:
      "칼렛스토어에서 주문하신 상품의 결제 내역과 배송 현황을 확인하세요. 간편한 주문 조회 시스템으로 친환경 포장재 주문 상태를 실시간으로 확인할 수 있습니다.",
    keywords:
      "칼렛스토어, 주문조회, 배송조회, 결제확인, 주문내역, 배송현황, 주문상태, 배송추적, 주문확인",
  },
  estimateCart: {
    title: "견적 바구니",
    description:
      "칼렛스토어 견적 바구니 페이지입니다. 담아둔 맞춤 제작 견적 항목을 확인하고 한 번에 요청하세요. 친환경 패키징 맞춤 견적을 간편하게 관리할 수 있습니다.",
    keywords:
      "견적 바구니, 칼렛스토어, 맞춤제작, 견적관리, 패키징견적, 맞춤포장재, 친환경패키징, 견적요청, 맞춤디자인",
  },
  estimateComplete: {
    title: "견적 요청 완료",
    description:
      "칼렛스토어 견적 요청이 성공적으로 완료되었습니다. 요청하신 맞춤 패키징 견적 내용을 확인하시고, 빠른 시일 내에 전문 상담사가 연락드릴 예정입니다.",
    keywords:
      "견적 요청 완료, 칼렛스토어, 맞춤제작확인, 견적신청, 패키징견적, 맞춤포장재, 제작요청완료, 견적상담, 친환경포장제작",
  },
  guide: {
    title: "제작 가이드",
    description:
      "칼렛스토어의 맞춤 패키징 제작 가이드입니다. 친환경 포장재 맞춤 제작을 위한 상세 안내와 디자인 가이드라인, 규격 정보 등을 확인하세요.",
    keywords:
      "제작 가이드, 칼렛스토어, 맞춤제작, 패키징가이드, 친환경포장제작, 디자인가이드, 포장재규격, 맞춤포장안내, 제작프로세스",
  },
  estimateRequest: {
    title: "견적요청",
    description:
      "칼렛스토어의 맞춤형 패키징 견적요청 서비스입니다. 귀사의 필요에 맞는 친환경 포장재 솔루션과 최적의 가격을 제안받으세요.",
    keywords:
      "견적요청, 칼렛스토어, 맞춤견적, 포장재견적, 친환경패키징, 맞춤제작견적, 패키징솔루션, 맞춤포장재, 비용견적",
  },
  designService: {
    title: "디자인 서비스",
    description:
      "간단한 교정, 재배치부터 패키지, 브랜드 디자인까지 전문 디자이너가 해드립니다. 칼렛스토어의 친환경 패키징 디자인 서비스로 브랜드 가치를 높이세요.",
    keywords:
      "디자인 서비스, 칼렛스토어, 패키징디자인, 브랜드디자인, 친환경디자인, 포장재디자인, 전문디자이너, 맞춤디자인, 패키지디자인",
  },
  portfolio: {
    title: "포트폴리오",
    description:
      "지속가능한 패키징을 제공하는 브랜드와 솔루션 사례를 이미지로 확인해보세요. 칼렛스토어의 다양한 친환경 포장재 제작 포트폴리오를 통해 아이디어를 얻으세요.",
    keywords:
      "포트폴리오, 칼렛스토어, 패키징사례, 제작사례, 친환경포장, 브랜드패키징, 디자인사례, 맞춤제작, 지속가능패키징",
  },
  groupPurchase: {
    title: "공동구매",
    description:
      "칼렛스토어의 친환경 포장재 공동구매 페이지입니다. 여러 기업과 함께 구매하여 더 저렴한 가격으로 고품질 친환경 패키징을 만나보세요.",
    keywords:
      "공동구매, 칼렛스토어, 친환경포장재, 특가이벤트, 단체구매, 대량구매, 할인구매, 포장재공구, 그룹구매",
  },
  myPage: {
    title: "마이페이지",
    description:
      "칼렛스토어 마이페이지에서 회원정보, 주문내역, 배송현황, 포인트, 쿠폰 등 다양한 개인 정보를 확인하고 관리하세요.",
    keywords:
      "마이페이지, 칼렛스토어, 회원정보, 주문내역, 배송현황, 포인트관리, 쿠폰관리, 회원서비스, 개인정보관리",
  },
  companyIntro: {
    title: "회사소개",
    description:
      "칼렛스토어는 지속가능한 미래를 위한 친환경 패키징 솔루션을 제공하는 전문기업입니다. 환경을 생각하는 혁신적인 포장재로 더 나은 내일을 만들어갑니다.",
    keywords:
      "회사소개, 칼렛스토어, 친환경기업, 패키징전문, 지속가능경영, 친환경미션, 포장재기업, 친환경가치, 기업철학",
  },
  smallPrintService: {
    title: "소량 인쇄 서비스",
    description:
      "칼렛스토어의 소량 인쇄 서비스를 이용해보세요. 100장부터 기성포장재에 인쇄 가능하며 동판비 0원, 재발주 시 디자인 변경까지 가능합니다.",
    keywords:
      "소량 인쇄, 칼렛스토어, 맞춤인쇄, 포장재인쇄, 소량주문, 동판비무료, 친환경인쇄, 패키징인쇄, 맞춤포장",
  },
  promotionalItemCreation: {
    title: "판촉물 제작",
    description:
      "칼렛스토어의 친환경 판촉물 제작 서비스로 브랜드 가치를 높이세요. 지속가능한 소재로 만든 다양한 판촉물로 효과적인 마케팅과 환경보호를 동시에 실현합니다.",
    keywords:
      "판촉물 제작, 칼렛스토어, 친환경판촉물, 지속가능마케팅, 친환경홍보물, 브랜드판촉물, 친환경마케팅, 친환경기업선물, 맞춤판촉물",
  },
  prototypeCreation: {
    title: "시제품 제작",
    description:
      "칼렛스토어의 친환경 패키징 시제품 제작 서비스를 소개합니다. 브랜드에 맞는 지속가능한 맞춤형 포장재 시제품으로 비즈니스의 친환경 가치를 높이세요.",
    keywords:
      "시제품 제작, 칼렛스토어, 친환경패키징, 맞춤형포장, 패키징솔루션, 친환경시제품, 포장재개발, 지속가능패키징, 맞춤제작",
  },
  carbonZeroCampaign: {
    title: "카본제로 환경운동",
    description:
      "칼렛스토어의 카본제로 환경운동에 동참하세요. 친환경 포장재 사용으로 탄소 배출을 줄이고 지속가능한 미래를 함께 만들어갑니다.",
    keywords:
      "카본제로, 환경운동, 칼렛스토어, 탄소중립, 친환경캠페인, 탄소저감, 지속가능환경, 친환경포장, 탄소배출감소",
  },
  caseStudiesAndPackagingReviews: {
    title: "제작사례 & 포장재리뷰",
    description:
      "지속가능한 패키징을 제공하는 브랜드와 솔루션 사례를 확인해보세요. 칼렛스토어가 소개하는 다양한 친환경 패키징 성공 사례와 포장재 리뷰를 통해 아이디어를 얻으세요.",
    keywords:
      "제작사례, 포장재리뷰, 칼렛스토어, 친환경패키징, 지속가능솔루션, 브랜드사례, 패키징솔루션, 친환경성공사례, 친환경브랜드",
  },
  materialsAndPackaging: {
    title: "소재와 포장재",
    description:
      "지속가능한 패키징 소재와 포장재 종류를 낱낱이 알려드립니다. 칼렛스토어의 친환경 소재 정보를 통해 환경을 생각하는 최적의 포장재를 선택하세요.",
    keywords:
      "소재와 포장재, 칼렛스토어, 친환경소재, 지속가능포장, 친환경패키징, 포장재종류, 생분해소재, 재활용소재, 친환경포장재",
  },
  packagingCertificationInfo: {
    title: "포장재 인증정보",
    description:
      "친환경 포장재에 대한 다양한 인증 제도와 기준, 국내외 적용 사례를 한눈에! 매일 업데이트되는 칼렛스토어 ESG 자료실에서 올바른 포장재 선택을 위한 인증정보를 확인해보세요.",
    keywords:
      "포장재 인증, 친환경 포장재, 포장재 기준, ESG 패키징, 환경인증제도, 지속가능 포장, 칼렛스토어, 친환경 인증마크, 재활용 포장재",
  },
  esgNews: {
    title: "ESG 환경뉴스",
    description:
      "알아두면 쓸모있는 정책, 뉴스, 국내외 패키징 트렌드, 적용사례! 매일 업데이트되는 칼렛스토어의 ESG 환경뉴스에서 친환경 패키징 정보를 확인하세요.",
    keywords:
      "ESG 환경뉴스, 칼렛스토어, 친환경패키징, 패키징트렌드, 환경정책, 지속가능소비, 친환경뉴스, 패키징사례, 친환경포장",
  },
  esgLibrary: {
    title: "ESG 자료실",
    description:
      "알아두면 쓸모있는 정책과 뉴스, 국내외 패키징 트렌드, 적용사례를 매일 업데이트합니다. 칼렛스토어의 ESG 자료실에서 친환경 패키징 관련 종합 정보를 확인하세요.",
    keywords:
      "ESG 자료실, 칼렛스토어, 친환경자료, 패키징정보, 환경정책자료, 지속가능패키징, ESG정보센터, 친환경포장자료, 패키징트렌드",
  },
  esgNewsletter: {
    title: "ESG 뉴스레터",
    description:
      "알아두면 쓸모있는 정책과 뉴스만 잘 선별해 빠르게 알려드립니다. 칼렛스토어의 ESG 뉴스레터를 통해 중요한 친환경 패키징 정보를 한눈에 확인하세요.",
    keywords:
      "ESG 뉴스레터, 칼렛스토어, 친환경소식, 패키징뉴스, 환경정책, 지속가능경영, 친환경트렌드, ESG정보, 친환경패키징",
  },
  cart: {
    title: "장바구니",
    description:
      "칼렛스토어 장바구니에서 선택한 상품을 확인하고 간편하게 결제하세요. 친환경 포장재 및 패키징 솔루션을 한 번에 구매할 수 있습니다.",
    keywords:
      "칼렛스토어, 장바구니, 온라인결제, 친환경포장재, 쇼핑카트, 주문하기, 패키징솔루션, 포장재구매",
  },
  customerCompanies: {
    title: "고객사",
    description:
      "칼렛스토어의 다양한 고객사들을 소개합니다. 친환경 포장재와 패키징 솔루션을 선택한 기업들과의 파트너십 사례를 확인하세요.",
    keywords:
      "칼렛스토어, 고객사, 파트너십, 친환경포장, 기업사례, 협력업체, 성공사례, 지속가능패키징, 기업파트너",
  },
  privacyPolicy: {
    title: "개인정보 처리방침",
    description:
      "칼렛스토어의 개인정보 처리방침을 확인하세요. 개인정보 수집 및 이용 목적, 보관 기간, 제3자 제공, 정보주체의 권리 등 관련 정책을 투명하게 공개합니다.",
    keywords:
      "칼렛스토어, 개인정보처리방침, 개인정보보호, 정보보호정책, 개인정보수집, 개인정보이용, 정보주체권리, 개인정보관리",
  },
  bestProducts: {
    title: "베스트 상품",
    description:
      "칼렛스토어의 인기 있는 베스트 상품을 만나보세요. 고객들이 가장 많이 선택한 친환경 포장재, 패키징 솔루션 및 친환경 제품들을 한눈에 확인할 수 있습니다.",
    keywords:
      "칼렛스토어, 베스트상품, 인기상품, 친환경포장재, 패키징솔루션, 친환경제품, 인기판매, 베스트셀러, 추천상품",
  },
  repurchase: {
    title: "재구매",
    description:
      "칼렛스토어에서 이전에 구매한 상품을 쉽고 빠르게 재구매하세요. 반복 주문이 필요한 친환경 포장재와 패키징 솔루션을 간편하게 다시 주문할 수 있습니다.",
    keywords:
      "칼렛스토어, 재구매, 반복주문, 이전구매, 주문내역, 친환경포장재, 패키징솔루션, 간편주문, 빠른주문",
  },
  terms: {
    title: "칼렛스토어 약관",
    description:
      "칼렛스토어의 공식 이용약관입니다. 회원가입, 주문, 결제, 배송, 환불 등에 관한 중요 정책을 확인하세요.",
    keywords:
      "칼렛스토어, 이용약관, 회원정책, 결제조건, 배송정책, 환불규정, 개인정보처리, 쇼핑몰약관",
  },
};
